import { User, UserFacadeService } from '@anecdotes/identity';
import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';
import { Observable, combineLatest, filter, map } from 'rxjs';
import { TrustCenterFacadeService } from '@anecdotes/shared-trust-center';
import { RoleEnum } from '@anecdotes/auth-core';

@Component({
  selector: 'app-notifications-settings',
  templateUrl: './notifications-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NotificationsSettingsComponent implements OnInit {
  @HostBinding('class')
  private readonly classes = 'flex flex-col w-full h-full bg-white border-l border-navy-40 overflow-hidden';

  usersStream$: Observable<User[]>;
  currentOwners$: Observable<User[]>;
  currentUserEmail$: Observable<string>;

  constructor(
    private trustCenterFacadeService: TrustCenterFacadeService,
    private userFacade: UserFacadeService,
  ) {}

  ngOnInit(): void {
    this.currentUserEmail$ = this.userFacade.getCurrentUser().pipe(map((user) => user.email));

    this.usersStream$ = this.userFacade.getUsers().pipe(map((users) => this.filterUsers(users)));

    const ownerEmails$ = this.trustCenterFacadeService.getSettings()
      .pipe(
        filter((settings) => !!settings),
        map((settings) => settings.owners),
      );

    this.currentOwners$ = combineLatest([this.usersStream$, ownerEmails$])
      .pipe(
        map(([users, ownerEmails]) => {
          return ownerEmails
            .map((email) => users.find((user) => user.email === email))
            .filter(Boolean);
        }),
      );
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.${key}`;
  }

  async updateOwners(newOwners: User[]): Promise<void> {
    const newOwnersEmails = newOwners.map((owner) => owner.email);

    await this.trustCenterFacadeService.updateSettings({ owners: newOwnersEmails });
  }


  private filterUsers(users: User[]): User[] {
    return users.filter((user) => {
      if (!user.role) {
        return;
      }

      return [RoleEnum.Admin, RoleEnum.Manager, RoleEnum.TrustCenterAccessManager].includes(user.role as RoleEnum);
    });
  }
}
